import * as runtime from "react/jsx-runtime";
import type React from "react";
import { ArticleBody } from "@/components/primitives/article";
import { mdxComponents } from "./mdx-components";

type MdxComponent = React.ComponentType<{ components?: typeof mdxComponents }>;
type MdxModule = { default: MdxComponent };
interface UncheckedMdxModule {
  default?: unknown;
}

function parseMdxModule(moduleValue: UncheckedMdxModule): MdxModule {
  if (!(moduleValue.default instanceof Function)) {
    throw new Error("Compiled MDX did not export a component");
  }
  const componentFactory = moduleValue.default;
  return {
    default: (props) => componentFactory(props),
  };
}

// Renders Velite-compiled MDX (function-body format) with the shared component map.
// Safe to call from server components — no client-only APIs used.
export function renderMdx(code: string) {
  const evaluate = new Function(code);
  const { default: Component } = parseMdxModule(evaluate({ ...runtime }));
  return (
    <ArticleBody>
      <Component components={mdxComponents} />
    </ArticleBody>
  );
}
